import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AuthService } from './auth.service';
import { ConfigService } from './config.service';
import { HttpClientModule } from '@angular/common/http';
import { PopupModule } from 'shared/popup-service/popup.module';
import { AuthTokenServiceModule } from '@kempoweroyj/ngx-auth-token-service';

@NgModule({
    declarations: [],
    imports: [CommonModule, HttpClientModule, PopupModule, AuthTokenServiceModule],
    exports: [],
    providers: [AuthService, ConfigService],
})
export class CeProvidersModule {}
